goog.provide('el8.app.pageLayout');

goog.require('el8.app.service.UILayout');


el8.app.pageLayout = new el8.app.service.UILayout();

